
import { Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IInputRender, InputType } from '../../models';

@Component({
  template: `
    <ng-content></ng-content>
  `,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: GsInputFieldController
    }
  ]
})
export abstract class GsInputFieldController implements ControlValueAccessor, OnInit {
  // Inputs
  /** The input to render */
  readonly input = input<IInputRender>();

  /**
   * Tailwind classes from the parent's primary action button styling. Applied to field components
   * that render a button (currently the file-input's select button). When empty, the field falls
   * back to classes computed from the global UI config.
   */
  readonly actionButtonClasses = input('');

  // References
  abstract readonly INPUT_TYPE_COMPONENTS: Record<InputType | 'NotFound', any>;

  // Properties
  /** The form control to bind to for this component */
  formCtrl: FormControl = new FormControl();
  /** Callback to trigger if the input got touched */
  _touched: () => void = () => {
    return;
  };

  // Getters & Setters
  /** The component to use for the input type */
  get component(): any {
    const inp = this.input();
    if (inp && inp.inputType >= 0) return this.INPUT_TYPE_COMPONENTS[inp.inputType];
    else return this.INPUT_TYPE_COMPONENTS['NotFound'];
  }

  // Methods
  ngOnInit(): void {
    if (!this.input()) {
      throw new Error('No input provided');
    }
  }

  // ControlValueAccessor Methods
  writeValue(val: string): void {
    this.formCtrl.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.formCtrl.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this._touched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.formCtrl.disable({ emitEvent: false });
    } else {
      this.formCtrl.enable({ emitEvent: false });
    }
  }
}
